import type { AgentTranscript, DocumentTextPage } from '~/entities/document-agent'
import { resultText } from './agent-steps'

const PAGE_MARKER = /<!--\s*page:\s*(\d+)\s*-->/g

/**
 * The pages the agent read with `get_pages`, from the transcript: the text to fall back on when
 * the document's own text cannot be loaded. Each page keeps the first text it was read with.
 */
export function getTranscriptPages(transcripts: Array<AgentTranscript | null>): DocumentTextPage[] {
  const pages = new Map<number, string>()
  for (const transcript of transcripts) {
    const toolNames = new Map<string, string>()
    for (const message of transcript?.messages ?? []) {
      if (!Array.isArray(message.content)) continue
      for (const block of message.content) {
        if (block.type === 'tool_use') toolNames.set(block.id, block.name)
        if (block.type !== 'tool_result' || toolNames.get(block.tool_use_id) !== 'get_pages')
          continue
        const text = resultText(block)
        const markers = [...text.matchAll(PAGE_MARKER)]
        markers.forEach((marker, index) => {
          const page = Number(marker[1])
          const start = (marker.index ?? 0) + marker[0].length
          const end = markers[index + 1]?.index ?? text.length
          if (!pages.has(page)) pages.set(page, text.slice(start, end).trim())
        })
      }
    }
  }
  return [...pages].sort(([a], [b]) => a - b).map(([page, text]) => ({ page, text }))
}
